<template>
  <div class="service-file-list-item service-file-list-item-audio">
    <div class="top">
      <div>
        <audio
          :id="id"
          :src="util.getImageUrl(item.url)"
          @canplaythrough="onCanPlayThrough"
          @timeupdate="onTimeUpdate"
          preload
        ></audio>

        <div class="controls" @click="onClick">
          <img src="@/assets/service/暂停.png" v-if="playing" />
          <img src="@/assets/service/播放.png" v-else />
        </div>

        <div class="time">
          <span>{{duration}}</span>
          <span class="current-time" v-if="currentTime">{{currentTime}}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <img src="@/assets/service/音频.png" alt /> 音频
      </div>

      <div class="download" @click="onDownload"></div>
    </div>
  </div>
</template>

<script>
import UUID from "uuid/v5";
import FileListItem from "./FileListItem";
export default {
  name: "FileListItemAudio",
  extends: FileListItem,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      id: UUID(this.item.url, UUID.URL),
      playing: false,
      duration: 0,
      currentTime: 0
    };
  },
  mounted() {},
  methods: {
    onCanPlayThrough(e) {
      const audio = document.getElementById(this.id);
      this.duration = this.util.duration2Time(audio.duration);
    },
    onTimeUpdate(e) {
      const audio = document.getElementById(this.id);
      this.currentTime = this.util.duration2Time(audio.currentTime);
    },
    onClick() {
      const audio = document.getElementById(this.id);
      if (this.playing) {
        audio.pause();
        this.playing = false;
      } else {
        audio.play();
        this.playing = true;
      }
    }
  }
};
</script>

<style lang="scss">
.service-file-list-item-audio {
  background: linear-gradient(
    360deg,
    rgba(158, 216, 177, 1) 0%,
    rgba(207, 240, 215, 1) 100%
  );

  position: relative;

  audio {
    height: 180px;
    border-radius: 5px;
  }

  .time {
    padding-top: 10px;
    text-align: center;
    height: 27px;
    font-size: 22px;
    font-family: "DIN Medium";
    color: rgba(27, 153, 79, 1);
    line-height: 27px;

    .current-time {
      padding-left: 10px;
      height: 15px;
      font-size: 12px;
      font-family: "DIN Medium";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
    }
  }
}
</style>